let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("adH3p"), load("9VvWo"), load("5uN9h"), load("jzQ6f")]).then(() => parcelRequire('ylKHA'));